import React from "react";



function Import(){
    return(
        <>
            <h1>Import page</h1>       
        </>
    )
}



export default Import;